import { render, staticRenderFns } from "./BlindStructureLayout.vue?vue&type=template&id=47e9d08d&"
import script from "./BlindStructureLayout.vue?vue&type=script&lang=js&"
export * from "./BlindStructureLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports